// extracted by mini-css-extract-plugin
export default {"container":"loader_container__hl4K4","img":"loader_img__VbmaH","spin":"loader_spin__BMJvm"};